<ngx-loading-bar></ngx-loading-bar>
<div style="min-height: 70vh">
  <!-- somewhere in your root component template -->
  <app-toast aria-live="polite" aria-atomic="true"></app-toast>
  <router-outlet></router-outlet>
</div>
